<header class="header profile-header" *ngIf="!showProfileHeader">
  <div class="Flexbox">
    <div class="header-content contnet-filters Flexbox Flexbox__flex-1 fs5">
      <gen-test-header-elements
        class="content-item Flexbox Spacebox__lr-small patient-profile profile-header-section"
        style="font-size: 1.21rem; flex-wrap: wrap; flex: 1 1 auto"
        [patientId]="patientId"
        [showPatientWarning]="showDuplicatePatient"
        [backUrl]="backUrl"
        [backUrlParams]="backUrlParams">
      </gen-test-header-elements>
      <gen-test-actions *ngIf="loaded" [isCustomConfig]="isCustomConfig" [addTestAvailable]="!currentUser.isAdmin" [previewMode]="previewMode" [showTestActions]="showTestActions"></gen-test-actions>
    </div>
  </div>
</header>
<div *ngIf="!stateParams.testId"><gen-empty-page></gen-empty-page></div>
<router-outlet [ngClass]="{'bottom-padding': !showProfileHeader}"></router-outlet>
<gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="'AllItemsChannel'"></gen-dynamic-modal-loader>
